const Section = ({ title, children }) => (
    <section className="mt-8">
        <h2 className="font-serif-display text-2xl font-semibold">{title}</h2>
        <div className="mt-3 text-sm leading-relaxed text-[var(--sss-text-muted)] space-y-3">{children}</div>
    </section>
);

export default function PrivacyPolicy() {
    return (
        <div className="max-w-3xl mx-auto px-4 md:px-8 py-12" data-testid="privacy-policy-page">
            <p className="text-center text-xs uppercase tracking-[0.2em] font-semibold text-[var(--sss-pink)]">Legal</p>
            <h1 className="font-serif-display text-4xl md:text-5xl font-bold text-center mt-2">Privacy Policy</h1>
            <p className="text-center text-sm text-[var(--sss-text-muted)] mt-3">Last updated: June 2026</p>

            <div className="bg-white rounded-3xl sss-shadow p-6 md:p-10 mt-10">
                <p className="text-sm leading-relaxed text-[var(--sss-text-muted)]">
                    Sugar Sweet Society (&quot;we&quot;, &quot;us&quot;) operates sugarsweetsociety.com. This policy explains what information we collect, how we use it, and your choices. By using our site, you agree to this policy.
                </p>

                <Section title="Information We Collect">
                    <p><strong className="text-[var(--sss-text)]">Order information:</strong> name, email, phone number, delivery address (if applicable), requested date, and order notes — collected when you place an order or submit a custom order request.</p>
                    <p><strong className="text-[var(--sss-text)]">Account information:</strong> if you sign in with Google, we receive your name, email address, and profile photo from Google. We never see or store your Google password.</p>
                    <p><strong className="text-[var(--sss-text)]">Email signups:</strong> your email address if you join our email list.</p>
                    <p><strong className="text-[var(--sss-text)]">Payment information:</strong> card payments are processed securely by Stripe. We never see or store your full card number. Cash App, PayPal, and Apple Pay payments happen directly in those apps.</p>
                </Section>

                <Section title="How We Use Your Information">
                    <p>We use your information only to: fulfill and communicate about your orders, respond to custom order requests and messages, and (if you opted in) send occasional emails about new treats and offers.</p>
                    <p>We do <strong className="text-[var(--sss-text)]">not</strong> sell, rent, or share your personal information with third parties for their marketing purposes.</p>
                </Section>

                <Section title="Cookies & Sessions">
                    <p>If you sign in, we use a secure session cookie to keep you signed in for up to 7 days. We also use basic analytics to understand how visitors use the site.</p>
                </Section>

                <Section title="Data Retention & Your Rights">
                    <p>We keep order records for our business and tax purposes. You may request access to, correction of, or deletion of your personal information at any time by emailing us.</p>
                    <p>To unsubscribe from marketing emails, reply &quot;unsubscribe&quot; to any email or contact us directly.</p>
                </Section>

                <Section title="Children's Privacy">
                    <p>Our site is not directed at children under 13, and we do not knowingly collect their personal information.</p>
                </Section>

                <Section title="Contact Us">
                    <p>
                        Questions about this policy? Email <a href="mailto:Laylah@sugarsweetsociety.com" className="underline text-[var(--sss-pink)]">Laylah@sugarsweetsociety.com</a>.
                    </p>
                </Section>
            </div>
        </div>
    );
}
